function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7.8 4.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-down-white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Giving-History"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Giving-History---Recurring-Gift"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.08.47a.24.24,0,0,0,0,.34l0,0L3.72,4.47a.24.24,0,0,0,.34,0l0,0L7.72.83a.24.24,0,0,0,0-.34l0,0L7.33.08A.24.24,0,0,0,7,.06l0,0L3.9,3.15.83.08a.24.24,0,0,0-.34,0l0,0Z",
    style: {
      fill: "#fff"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownWhite);
export default __webpack_public_path__ + "static/media/arrow-down-white.9455136c1ef9c1267ac76b6b6fa3f524.svg";
export { ForwardRef as ReactComponent };